import { useParams, Link } from "react-router-dom";
import { getStoriesByCategory } from "~/stories";
import { CATEGORIES } from "~/types/story";
import StoryCard from "~/components/StoryCard";

export default function CategoryPage() {
  const { category } = useParams<{ category: string }>();
  const categoryInfo = CATEGORIES.find((c) => c.id === category);
  const categoryStories = getStoriesByCategory(category || "");

  if (!categoryInfo) {
    return (
      <div className="max-w-4xl mx-auto p-8 text-center">
        <h1 className="text-2xl mb-4">Category not found</h1>
        <Link to="/" className="text-blue-600 hover:underline">&larr; Back to home</Link>
      </div>
    );
  }

  return (
    <div className="min-h-screen">
      <div className="bg-gray-50 dark:bg-gray-800 py-12 px-6">
        <div className="max-w-6xl mx-auto">
          <Link to="/" className="text-gray-500 hover:text-gray-700 dark:text-gray-400 text-sm mb-4 inline-block">
            &larr; Back to home
          </Link>
          <h1 className="text-4xl font-bold mb-2 text-gray-900 dark:text-white">{categoryInfo.label}</h1>
          <p className="text-lg text-gray-600 dark:text-gray-300">{categoryInfo.description}</p>
          <p className="text-sm text-gray-400 mt-2">{categoryStories.length} stories across all age groups</p>
        </div>
      </div>

      <div className="max-w-6xl mx-auto px-6 py-8">
        {/* Group by age */}
        {["0-2", "3-5", "6-8", "9-12"].map((age) => {
          const ageStories = categoryStories.filter((s) => s.ageGroup === age);
          if (ageStories.length === 0) return null;
          return (
            <div key={age} className="mb-12">
              <h2 className="text-xl font-bold mb-4 text-gray-800 dark:text-gray-200">
                Ages {age}
              </h2>
              <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
                {ageStories.map((story) => (
                  <StoryCard key={story.id} story={story} />
                ))}
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
}
